import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { company } from "@/data/company";

const links = [
  { label: "Services", href: "/#services" },
  { label: "About", href: "/#about" },
  { label: "Why Us", href: "/#why" },
  { label: "Blog", href: "/blog" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-[#0a0f1e]/80 backdrop-blur-xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo" className="flex items-center">
          <img
            src="/logo-header.png"
            alt={`${company.name} logo`}
            className="h-12 w-auto object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-sm font-semibold text-slate-300 hover:text-[#22d3ee] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#contact"
            data-testid="nav-cta"
            className="bg-[#22d3ee] text-[#0a0f1e] text-sm font-bold px-6 py-2.5 rounded-sm hover:bg-[#67e8f9] transition-colors"
          >
            Get in touch
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#0a0f1e]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-semibold text-slate-200 hover:text-[#22d3ee]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#contact"
            onClick={() => setOpen(false)}
            className="bg-[#22d3ee] text-[#0a0f1e] text-center font-bold px-6 py-3 rounded-sm"
          >
            Get in touch
          </a>
        </div>
      )}
    </header>
  );
};
